import { useEffect, useState } from 'react'

import NexiaStream from 'services/NexiaStream'

import { useSessionContext } from 'hooks/SessionContext'
import { usePremiumFeaturesContext } from 'hooks/PremiumFeaturesContext'

import Brand from 'helpers/brand'
import Environment from 'helpers/environment'

const useSiteMessageBanners = () => {
  const { session: { isUnknown, currentRole, dealerPlan } } = useSessionContext()
  const [siteMessageBanners, setSiteMessageBanners] = useState(null)
  const brand = Brand.current()
  const { premiumFreeTrial } = usePremiumFeaturesContext()
  const tier = premiumFreeTrial ? 'trial' : dealerPlan.tier

  const url = `${Environment.backendApiURL()}/stream/site_messages/${brand}/${tier}`

  useEffect(() => {
    if (isUnknown) {
      return
    }

    const eventListenerCallback = (event) => {
      if (event.data) {
        const report = JSON.parse(event.data)

        setSiteMessageBanners(report)
      }
    }

    NexiaStream.instance().addEventListener(`${brand}_${tier}_${currentRole}_site_message_banners`, eventListenerCallback)

    NexiaStream.instance().whenConnected(() =>
      NexiaStream.instance().subscribeTo(url)
    )

    return () => {
      NexiaStream.instance().removeEventListener(`${brand}_${tier}_${currentRole}_site_message_banners`, eventListenerCallback)
    }
  }, [isUnknown, url, brand, tier, currentRole])

  return { siteMessageBanners }
}

export default useSiteMessageBanners
